import React, { CSSProperties, ReactElement } from 'react';
import classNames from 'classnames';
import {
    NormalMenuItemHeaderLinkSC,
    NormalMenuItemHeaderSC,
} from './NormalMenu.styled';
import Icon from 'components/icon/Icon';

interface Props {
    text: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    onClick?: () => void;
    isOpened: boolean;
    nonClickable: boolean;
    justOnMobile?: boolean;
    iconStyle?: CSSProperties;
    link?: string;
    active?: boolean;
}

const headerContent = (
    text: string,
    icon: React.FC<React.SVGProps<SVGSVGElement>>,
    iconStyle: CSSProperties,
    showToggle: boolean,
    isOpened: boolean
): ReactElement => (
    <div className="flex" title={text}>
        <span className="left">
            {icon && <Icon icon={icon} style={iconStyle} className="icon" />}
            {text}
        </span>
        <div className="right">
            {showToggle && (
                <span
                    className={classNames('toggleIcon', {
                        open: isOpened,
                    })}
                />
            )}
        </div>
    </div>
);

const NormalMenuItemHeader = ({
    text,
    icon,
    justOnMobile,
    onClick,
    isOpened,
    nonClickable,
    iconStyle,
    link,
    active,
}: Props): ReactElement => {
    if (link) {
        return (
            <NormalMenuItemHeaderLinkSC
                className={classNames({
                    justOnMobile,
                    active,
                })}
                href={link}
                title={text}
            >
                {headerContent(text, icon, iconStyle, false, false)}
            </NormalMenuItemHeaderLinkSC>
        );
    }

    return (
        <NormalMenuItemHeaderSC
            className={classNames({
                pointer: !nonClickable,
                nonClickable,
                justOnMobile,
            })}
            onClick={onClick}
        >
            {headerContent(text, icon, iconStyle, !nonClickable, isOpened)}
        </NormalMenuItemHeaderSC>
    );
};

export default NormalMenuItemHeader;
